import React from 'react';
import MatchedListingsTable from './matched_listings_table';
import Snackbar from 'shared/snackbar';
import { connect } from 'react-redux';
import type { FlashState } from '../types';
import { clearFlash } from '../store/actions';
import UnmatchedListingsTables from './unmatched_listings_tables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';

type LayoutProps = {
  flash: FlashState,
  clearFlash: () => void;
  unmatchedListingCount: number;
}

function Layout({ flash, clearFlash, unmatchedListingCount } : LayoutProps) {
  const currentUrl = new URL(window.location.href);
  const zipUrl = `${currentUrl.origin}${currentUrl.pathname}.zip${currentUrl.search}`;

  return (
    <div className="p-2">
      <Snackbar
        sautoHideDuration={5000}
        show={flash?.show}
        text={flash?.message}
        variant={flash?.variant || 'success'}
        onClose={clearFlash}
      />
      <div className="text-right">
        <a className="btn btn-link btn-lg  text-primary" href={zipUrl}>
          <FontAwesomeIcon icon={faDownload} />
        </a>
      </div>
      <MatchedListingsTable />
      <UnmatchedListingsTables count={unmatchedListingCount}/>
    </div>
  );
}

const mapStateToProps = ({ ui: { flash }, listings: { unmatchedAnywhereListings, unmatchedBuildoutListings } }) => ({
  flash,
  unmatchedListingCount: (unmatchedBuildoutListings.length + unmatchedAnywhereListings.length)
});

export default connect(mapStateToProps, { clearFlash })(Layout);
